module.exports = __webpack_public_path__ + "static/Star_Wars_2-22bdb2b0da36e78ef4c98ef3e1f514d6.gif";